export const apiUrl =
  process.env.REACT_APP_API_URL ||
  "https://us-central1-digital-coupon-book-cf832.cloudfunctions.net/api";

// Environment-level kill switch: when true, the per-org "testing mode" toggle
// is shown in the UI and the server respects it to bypass Stripe. Must be
// false in production.
export const allowStripeBypass =
  process.env.REACT_APP_ALLOW_STRIPE_BYPASS === "true";

// Environment-level kill switch: when true, the campaign editor renders the
// "Preview on iPhone" QR that points at /wallet/apple/:campaignId/000000.
// The server independently 403s that route when its own ALLOW_WALLET_PREVIEW
// env var is unset, so flipping only this client flag without enabling the
// backend flag will fail at scan time. Must be false in production.
export const allowWalletPreview =
  process.env.REACT_APP_ALLOW_WALLET_PREVIEW === "true";

// When true, the "Choose from Pexels" picker on the campaign hero-image form
// opens a real search modal. When false, clicking the button shows a
// "Coming Soon" toast instead. The server independently 503s /pexels/search
// when PEXELS_API_KEY is unset, so flipping only this flag without setting
// the backend key will fail at request time.
export const pexelsEnabled =
  process.env.REACT_APP_PEXELS_ENABLED === "true";
